import { Query } from '@varo/graphql-schema-types';
import FetchUser from 'services/graphql/queries/FetchUser';
import { useQuery } from 'urql';

const useActivationCard = (cardId: string) => {
  const [{ data: response, fetching, error }] = useQuery<Query>({
    query: FetchUser,
    requestPolicy: 'network-only',
  });
  const cardData = response?.cards?.find((card) => card.id === cardId);
  const cardStatus = cardData?.status;
  const isPinSet = cardData?.isPinSet;
  const cardType = cardData?.type;
  return {
    fetching,
    cardStatus,
    cardType,
    isPinSet,
    error,
    // need a way to tell whether we have a response or not since the
    // request could succeed and all values could still be undefined
    hasResponse: Boolean(response),
  };
};

export default useActivationCard;
